import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    '@keyframes skeleton': {
      from: { opacity: 0.5 },
      to: { opacity: 1 },
    },

    block: {
      display: 'block',
    },

    round: {
      display: 'inline-flex',
      borderRadius: '50%',
      overflow: 'hidden',
      height: '100%',
      '& span': {
        display: 'inline-flex',
      },
    },

    root: {
      pointerEvents: 'none',
      color: 'transparent !important',

      '& *': {
        color: 'inherit !important',
      },

      '& img': {
        opacity: 0,
      },

      '& span': {
        background: '#00000014',
        animation: '$skeleton 1s infinite ease-in-out alternate',
        borderRadius: 2,
      },
    },
  },
  {
    name: 'Skeleton',
  },
);
